export default {
  purchaseOrders: [],
  purchaseOrder: undefined,
};
